import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  search: {
    minWidth: 250,
    maxWidth: 360
  },
  segmented: {
    width: 'fit-content'
  },
  qrWrapper: {
    backgroundColor: token.colorWhite,
    padding: '8px 16px'
  },
  button: {
    width: 'fit-content'
  },
  divider: {
    marginBlock: 24
  },
  resultDivider: {
    marginBlock: 0
  },
  // Highlights a specimen row that still needs action from the current user.
  // The tint persists on hover (hence !important) so it reads as a status,
  // not a transient hover state.
  needsProcessingRow: {
    '& > td': {
      fontWeight: 600,
      backgroundColor: `${token.colorWarningBg} !important`
    }
  }
}))
